import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OscardStaticService } from 'projects/common/services/oscard-static.service';
import { PaymentPromoData } from '../payment-promos-model';

@Component({
  selector: 'payment-promo-card',
  template: `
    <div class="card eva-3-card" (click)="onCardClickNoFiltered()" >

      <img class="image-section" [src]='getImgSrc()' alt="Imagen del banco" />

      <div class="content-section">
        <div class="text-section">
          <div class="eva-3-h6 -eva-3-tc-gray-0 promo-title">{{ promoData.title }}</div>
          <div class="eva-3-body-2 -eva-3-tc-gray-1 promo-subtitle">{{ promoData.subtitle }}</div>
        </div>
        
        <div class="eva-3-link eva-3-h5" (click)="onCardClick()">{{ 'legal.seeConditions' | translate}}</div>
      </div>
      
    </div>
  `,
  styleUrls: ['./payment-promo-cards.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PaymentPromoCard {
  @Input() promoData: PaymentPromoData;
  @Output() focusBanner = new EventEmitter<string>();

  constructor(private oscardStaticService: OscardStaticService) {}

  onCardClickNoFiltered() {
    this.focusBanner.emit(this.promoData.anchor);
  }

  onCardClick() {
    this.focusBanner.emit(this.promoData.id);
  }
  
  getImgSrc(): string {
    return this.oscardStaticService.getBankPictureUrl(this.promoData.bank_code);
  }
}
